module.exports = __webpack_public_path__ + "img/tools.6d77d1e5.svg";